// extracted by mini-css-extract-plugin
export var blue = "#0eb3f2";
export var competitor = "MatchPageSkeleton-module--competitor--b7d8c";
export var competitorIcon = "MatchPageSkeleton-module--competitorIcon--d06f8";
export var competitorName = "MatchPageSkeleton-module--competitorName--edeef";
export var competitors = "MatchPageSkeleton-module--competitors--613e0";
export var counter = "MatchPageSkeleton-module--counter--baf1f";
export var emphasis = "MatchPageSkeleton-module--emphasis--7272b";
export var green = "#57d33b";
export var greenLink = "MatchPageSkeleton-module--green-link--d016d";
export var grey = "var(--tone-mid)";
export var notchGap = "32px";
export var orange = "#f8662b";
export var page = "MatchPageSkeleton-module--page--629f7";
export var red = "#ff2741";
export var separator = "MatchPageSkeleton-module--separator--15381";
export var title = "MatchPageSkeleton-module--title--7647d";
export var titleBlock = "MatchPageSkeleton-module--titleBlock--6c04e";
export var titleIcon = "MatchPageSkeleton-module--titleIcon--a06fb";
export var widthDesktop = "1024px";
export var widthDesktopXl = "1280px";
export var widthExpanded = "1536px";
export var widthMobile = "640px";
export var widthTablet = "768px";
export var withMargin = "MatchPageSkeleton-module--withMargin--be47d";
export var yellow = "#ffb100";